/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { NistCsfWizardCatalogCategoryNodeDto } from './NistCsfWizardCatalogCategoryNodeDto';
import {
    NistCsfWizardCatalogCategoryNodeDtoFromJSON,
    NistCsfWizardCatalogCategoryNodeDtoFromJSONTyped,
    NistCsfWizardCatalogCategoryNodeDtoToJSON,
    NistCsfWizardCatalogCategoryNodeDtoToJSONTyped,
} from './NistCsfWizardCatalogCategoryNodeDto';

/**
 * NIST CSF function (GV, ID, PR, etc.) with categories and controls for the wizard
 * @export
 * @interface NistCsfWizardCatalogFunctionNodeDto
 */
export interface NistCsfWizardCatalogFunctionNodeDto {
    /**
     * UUID of the function group
     * @type {string}
     * @memberof NistCsfWizardCatalogFunctionNodeDto
     */
    functionId?: string;
    /**
     * Display title for the function
     * @type {string}
     * @memberof NistCsfWizardCatalogFunctionNodeDto
     */
    functionTitle?: string;
    /**
     * Categories under this function
     * @type {Array<NistCsfWizardCatalogCategoryNodeDto>}
     * @memberof NistCsfWizardCatalogFunctionNodeDto
     */
    categories?: Array<NistCsfWizardCatalogCategoryNodeDto>;
}

/**
 * Check if a given object implements the NistCsfWizardCatalogFunctionNodeDto interface.
 */
export function instanceOfNistCsfWizardCatalogFunctionNodeDto(value: object): value is NistCsfWizardCatalogFunctionNodeDto {
    return true;
}

export function NistCsfWizardCatalogFunctionNodeDtoFromJSON(json: any): NistCsfWizardCatalogFunctionNodeDto {
    return NistCsfWizardCatalogFunctionNodeDtoFromJSONTyped(json, false);
}

export function NistCsfWizardCatalogFunctionNodeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NistCsfWizardCatalogFunctionNodeDto {
    if (json == null) {
        return json;
    }
    return {
        
        'functionId': json['functionId'] == null ? undefined : json['functionId'],
        'functionTitle': json['functionTitle'] == null ? undefined : json['functionTitle'],
        'categories': json['categories'] == null ? undefined : ((json['categories'] as Array<any>).map(NistCsfWizardCatalogCategoryNodeDtoFromJSON)),
    };
}

export function NistCsfWizardCatalogFunctionNodeDtoToJSON(json: any): NistCsfWizardCatalogFunctionNodeDto {
    return NistCsfWizardCatalogFunctionNodeDtoToJSONTyped(json, false);
}

export function NistCsfWizardCatalogFunctionNodeDtoToJSONTyped(value?: NistCsfWizardCatalogFunctionNodeDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'functionId': value['functionId'],
        'functionTitle': value['functionTitle'],
        'categories': value['categories'] == null ? undefined : ((value['categories'] as Array<any>).map(NistCsfWizardCatalogCategoryNodeDtoToJSON)),
    };
}

